<div class="conversion-warnings" *ngIf="conversionResult">
	<!-- Overall Status -->
	<div class="status-summary" [ngClass]="statusColor">
		<mat-icon class="status-icon">{{ statusIcon }}</mat-icon>
		<div class="status-content">
			<div class="status-message">{{ statusMessage }}</div>
			<div class="statistics">
				<span>Total Nodes: {{ conversionResult.statistics.totalNodes }}</span>
				<span *ngIf="conversionResult.statistics.complexBranches > 0"
					>Complex Branches: {{ conversionResult.statistics.complexBranches }}</span
				>
				<span *ngIf="conversionResult.statistics.hiddenFields > 0"
					>Hidden Fields: {{ conversionResult.statistics.hiddenFields }}</span
				>
			</div>
		</div>
	</div>

	<!-- Errors -->
	<mat-expansion-panel *ngIf="errors.length > 0" class="warning-panel error-panel" [expanded]="true">
		<mat-expansion-panel-header>
			<mat-panel-title>
				<mat-icon>error</mat-icon>
				<span>Errors ({{ errors.length }})</span>
			</mat-panel-title>
			<mat-panel-description> These nodes could not be converted </mat-panel-description>
		</mat-expansion-panel-header>
		<div class="warning-list">
			<div *ngFor="let warning of errors; let i = index" class="warning-item">
				<div class="warning-header">
					<span class="warning-number">{{ i + 1 }}.</span>
					<span class="warning-node-name">{{ warning.nodeName }}</span>
					<span class="warning-block-type">{{ warning.blockType }}</span>
				</div>
				<div class="warning-message">{{ warning.message }}</div>
				<div *ngIf="warning.suggestion" class="warning-suggestion">
					<mat-icon>lightbulb</mat-icon>
					<span>{{ warning.suggestion }}</span>
				</div>
			</div>
		</div>
	</mat-expansion-panel>

	<!-- Warnings -->
	<mat-expansion-panel *ngIf="warnings.length > 0" class="warning-panel warning-panel-warn" [expanded]="true">
		<mat-expansion-panel-header>
			<mat-panel-title>
				<mat-icon>warning</mat-icon>
				<span>Warnings ({{ warnings.length }})</span>
			</mat-panel-title>
			<mat-panel-description> These nodes require manual review </mat-panel-description>
		</mat-expansion-panel-header>
		<div class="warning-list">
			<div *ngFor="let warning of warnings; let i = index" class="warning-item">
				<div class="warning-header">
					<span class="warning-number">{{ i + 1 }}.</span>
					<span class="warning-node-name">{{ warning.nodeName }}</span>
					<span class="warning-block-type">{{ warning.blockType }}</span>
				</div>
				<div class="warning-message">{{ warning.message }}</div>
				<div *ngIf="warning.suggestion" class="warning-suggestion">
					<mat-icon>lightbulb</mat-icon>
					<span>{{ warning.suggestion }}</span>
				</div>
			</div>
		</div>
	</mat-expansion-panel>

	<!-- Informational -->
	<mat-expansion-panel *ngIf="infos.length > 0" class="warning-panel info-panel" [expanded]="false">
		<mat-expansion-panel-header>
			<mat-panel-title>
				<mat-icon>info</mat-icon>
				<span>Informational ({{ infos.length }})</span>
			</mat-panel-title>
			<mat-panel-description> Additional conversion notes </mat-panel-description>
		</mat-expansion-panel-header>
		<div class="warning-list">
			<div *ngFor="let info of infos; let i = index" class="warning-item">
				<div class="warning-header">
					<span class="warning-number">{{ i + 1 }}.</span>
					<span class="warning-node-name">{{ info.nodeName }}</span>
					<span class="warning-block-type">{{ info.blockType }}</span>
				</div>
				<div class="warning-message">{{ info.message }}</div>
			</div>
		</div>
	</mat-expansion-panel>
</div>
